import React, { Component } from 'react';
import Search from "../../../../search/search";


class Search_IndReport extends Component {
    render() {
        return (
            <div>
                <div class="col-md-12 cateReports_col-md" >
                    <Search/>
                </div>
                {/*<div class="col-md-2 cate_reports_marginTop" >*/}
                    {/*<span class="advanced">*/}
                        {/*<a href="https://mordorintelligence.com:81/advanced-search/">Advanced Search</a>*/}
                    {/*</span>*/}
                {/*</div>*/}
            </div>
        );
    }


}


export default Search_IndReport;


// WEBPACK FOOTER //
// ./src/industry-reports/content/cate-reports/search/search.js